// // src/redux/store.js
// import { configureStore } from "@reduxjs/toolkit";
// import communityReducer from "../Services/Community/CommunitySlice/communitySlice";
// import communityByIdReducer from "../Services/Community/CommunitySlice/communityByIdSlice";
// import userLoginReducer from "../Services/Login/LoginSlice/loginSlice";
// import forgotPasswordReducer from "../Services/Login/LoginSlice/ForgotPasswordslice";
// import otpVerificationReducer from "../Services/Login/LoginSlice/otpverificationSlice";
// import userResetPasswordReducer from "../Services/Login/LoginSlice/ResetPasswordSlice";
// import userSignUpReducer from "../Services/Signup/SignupSlice/SignupSlice";
// import fetchUserTypeReducer from "../Services/Signup/SignupSlice/userTypeSlice";
// import idReducer from "../Services/Community/CommunitySlice/idSlice";
// import createNewCommunitySlice from "../Services/Community/CommunitySlice/createNewCommunitySlice";
// import communityUpdateSlice from "../Services/Community/CommunitySlice/communityUpdateSlice";
// import fetchProfileDataSlice from "../Services/Profile/ProfileSlice";
// import uiReducer from "../Services/DashboardHeader/uiSlice";
// import updateProfileApiSlice from "../Services/updateProfile/updateProfileSlice";
// import sessionReducer from "../Services/ChatSession/sessionSlice";  // ✅ Import sessionSlice
// import chatHistoryReducer from "../Services/ChatSession/chatHistorySlice"; // ✅ Import chat history slice
// import storage from "redux-persist/lib/storage"; // ✅ LocalStorage use karein
// import { persistStore, persistReducer } from "redux-persist";

// // ✅ Persist Config for Chat History
// const chatHistoryPersistConfig = {
//   key: "chatHistory",
//   storage, 
// };


// // ✅ Persist Config for Session
// const sessionPersistConfig = {
//   key: "session",
//   storage, 
// };


// // ✅ Persisted Reducers
// const persistedChatHistoryReducer = persistReducer(persistConfig, chatHistoryReducer);
// const persistedSessionReducer = persistReducer(persistConfig, sessionReducer);

// const store = configureStore({
//   reducer: {
//     community: communityReducer,
//     communityById: communityByIdReducer,
//     userLogin: userLoginReducer,
//     forgotPassword: forgotPasswordReducer,
//     otpVerification: otpVerificationReducer,
//     userResetPassword: userResetPasswordReducer,
//     userSignUp: userSignUpReducer,
//     fetchUserType: fetchUserTypeReducer,
//     id: idReducer,
//     createNewCommunity: createNewCommunitySlice,
//     communityUpdate: communityUpdateSlice,
//     fetchProfileData: fetchProfileDataSlice,
//     ui: uiReducer,
//     profileUpdate: updateProfileApiSlice,
//     // session: sessionReducer,  // ✅ Add session reducer
//     // chatHistory: chatHistoryReducer, // ✅ Add reducer

//     session: persistedSessionReducer, // ✅ Persist session data
//     chatHistory: persistedChatHistoryReducer, // ✅ Persist chat history
    

    
//   },
// });
// console.log("🛠 Persisted Data:", storage.getItem("persist:root")); // ✅ Debugging ke liye
// // ✅ Persistor Create Karein
// export const persistor = persistStore(store);

// export default store;



// src/redux/store.js
// import { configureStore } from "@reduxjs/toolkit";
// import communityReducer from "../Services/Community/CommunitySlice/communitySlice";
// import communityByIdReducer from "../Services/Community/CommunitySlice/communityByIdSlice";
// import userLoginReducer from "../Services/Login/LoginSlice/loginSlice";
// import forgotPasswordReducer from "../Services/Login/LoginSlice/ForgotPasswordslice";
// import otpVerificationReducer from "../Services/Login/LoginSlice/otpverificationSlice";
// import userResetPasswordReducer from "../Services/Login/LoginSlice/ResetPasswordSlice";
// import userSignUpReducer from "../Services/Signup/SignupSlice/SignupSlice";
// import fetchUserTypeReducer from "../Services/Signup/SignupSlice/userTypeSlice";
// import idReducer from "../Services/Community/CommunitySlice/idSlice";
// import createNewCommunitySlice from "../Services/Community/CommunitySlice/createNewCommunitySlice";
// import communityUpdateSlice from "../Services/Community/CommunitySlice/communityUpdateSlice";
// import fetchProfileDataSlice from "../Services/Profile/ProfileSlice";
// import uiReducer from "../Services/DashboardHeader/uiSlice";
// import updateProfileApiSlice from "../Services/updateProfile/updateProfileSlice";
// import sessionReducer from "../Services/ChatSession/sessionSlice";  // ✅ Import sessionSlice
// import chatHistoryReducer from "../Services/ChatSession/chatHistorySlice"; // ✅ Import chat history slice

// import storage from "redux-persist/lib/storage"; // ✅ LocalStorage use karein
// import { persistStore, persistReducer } from "redux-persist";

// // ✅ Persist Config for Chat History
// const chatHistoryPersistConfig = {
//   key: "chatHistory",
//   storage,
// };

// // ✅ Persist Config for Session
// const sessionPersistConfig = {
//   key: "session",
//   storage,
// };

// // ✅ Persisted Reducers
// const persistedChatHistoryReducer = persistReducer(chatHistoryPersistConfig, chatHistoryReducer);
// const persistedSessionReducer = persistReducer(sessionPersistConfig, sessionReducer);

// const store = configureStore({
//   reducer: {
//     community: communityReducer,
//     communityById: communityByIdReducer,
//     userLogin: userLoginReducer,
//     forgotPassword: forgotPasswordReducer,
//     otpVerification: otpVerificationReducer,
//     userResetPassword: userResetPasswordReducer,
//     userSignUp: userSignUpReducer,
//     fetchUserType: fetchUserTypeReducer,
//     id: idReducer,
//     createNewCommunity: createNewCommunitySlice,
//     communityUpdate: communityUpdateSlice,
//     fetchProfileData: fetchProfileDataSlice,
//     ui: uiReducer,
//     profileUpdate: updateProfileApiSlice,

//     // ✅ Persisted reducers
//     session: persistedSessionReducer,
//     chatHistory: persistedChatHistoryReducer,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false, // ✅ Redux Persist ke serialization error avoid karne ke liye
//     }),
// });

// // ✅ Persistor Create Karein
// export const persistor = persistStore(store);

// export default store;


import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // ✅ LocalStorage use karein

// ✅ Import Your Existing Reducers
import communityReducer from "../Services/Community/CommunitySlice/communitySlice";
import communityByIdReducer from "../Services/Community/CommunitySlice/communityByIdSlice";
import userLoginReducer from "../Services/Login/LoginSlice/loginSlice";
import forgotPasswordReducer from "../Services/Login/LoginSlice/ForgotPasswordslice";
import otpVerificationReducer from "../Services/Login/LoginSlice/otpverificationSlice";
import userResetPasswordReducer from "../Services/Login/LoginSlice/ResetPasswordSlice";
import userSignUpReducer from "../Services/Signup/SignupSlice/SignupSlice";
import fetchUserTypeReducer from "../Services/Signup/SignupSlice/userTypeSlice";
import idReducer from "../Services/Community/CommunitySlice/idSlice";
import createNewCommunitySlice from "../Services/Community/CommunitySlice/createNewCommunitySlice";
import communityUpdateSlice from "../Services/Community/CommunitySlice/communityUpdateSlice";
import fetchProfileDataSlice from "../Services/Profile/ProfileSlice";
import uiReducer from "../Services/DashboardHeader/uiSlice";
import updateProfileApiSlice from "../Services/updateProfile/updateProfileSlice";
import chatHistoryReducer from "../Services/ChatSession/chatHistorySlice";
import chatDataSlice from "../Services/ChatSession/chatDataSlice";
// ✅ Session Slice (for sessionId)
import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: { sessionId: null },
  reducers: {
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
  },
});

export const { setSessionId } = sessionSlice.actions;
export const selectSessionId = (state) => state.session.sessionId;

// ✅ Persist Configurations
const chatHistoryPersistConfig = {
  key: "chatHistory",
  storage,
};

const sessionPersistConfig = {
  key: "session",
  storage,
};

// ✅ Persisted Reducers
const persistedChatHistoryReducer = persistReducer(chatHistoryPersistConfig, chatHistoryReducer);
const persistedSessionReducer = persistReducer(sessionPersistConfig, sessionSlice.reducer);

const store = configureStore({
  reducer: {
    community: communityReducer,
    communityById: communityByIdReducer,
    userLogin: userLoginReducer,
    forgotPassword: forgotPasswordReducer,
    otpVerification: otpVerificationReducer,
    userResetPassword: userResetPasswordReducer,
    userSignUp: userSignUpReducer,
    fetchUserType: fetchUserTypeReducer,
    id: idReducer,
    createNewCommunity: createNewCommunitySlice,
    communityUpdate: communityUpdateSlice,
    fetchProfileData: fetchProfileDataSlice,
    ui: uiReducer,
    profileUpdate: updateProfileApiSlice,
    chatMessages : chatDataSlice,
    
    // ✅ Persisted reducers
    session: persistedSessionReducer,
    chatHistory: persistedChatHistoryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // ✅ Redux Persist ke serialization error avoid karne ke liye
    }),
});

// ✅ Persistor Create Karein
export const persistor = persistStore(store);
export default store;
